import { Component, OnInit } from '@angular/core';
import { Ticket, ShoppingCartService } from 'src/app/services/shopping-cart.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-payment-calculation',
  templateUrl: './payment-calculation.component.html',
  styleUrls: ['./payment-calculation.component.css']
})
export class PaymentCalculationComponent implements OnInit {

  tickets: Ticket[] = [];

  constructor(
    public cart: ShoppingCartService,
    private snackBar: MatSnackBar) { }

  get totalPrice(): number {
    let total = 0;
    for (const ticket of this.cart.basket.tickets) {
      total = total + Number(ticket.event.totalPrice);
    }
    return total;
  }

  get payable(): number {
    let total = 0;
    for (const ticket of this.cart.basket.tickets) {
      total = total + Number(ticket.price);
    }
    return total;
  }
  get discount(): number {
    return this.totalPrice - this.payable;
  }
  ngOnInit() {
    this.tickets = this.cart.basket.tickets;

  }

  public applyDiscountCode(ticket: Ticket, event): void {
    this.cart.priceChangedInbasket.emit(true);
    if (event.target.value.trim() === '') {
      ticket.calculatedPrice = ticket.event.totalPrice;
      ticket.discountCode = undefined;
      return;
    }
    if (ticket.event.discountCode && ticket.event.discountCode === event.target.value) {
      ticket.calculatedPrice = ticket.event.discountPrice;
      ticket.discountCode = event.target.value;

      this.snackBar.open( 'Dicsount is applied to this ticket!', '', {
        duration: 1000,
      });
    } else {
      ticket.calculatedPrice = ticket.event.totalPrice;
      ticket.discountCode = undefined;
      this.snackBar.open(event.target.value + ' is not a correct discount code.', '', {
        duration: 1000,
      });
      event.target.value = '';
    }
    // console.log('discount code', event.target.value);
  }

}
